export class CssHelper {
  // Get the value of a CSS Custom Property
  // default element is :root
  static getVar(propName, element = document.documentElement) {
    return getComputedStyle(element).getPropertyValue(propName)
  }
}
